import { Component, OnInit } from '@angular/core';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';
import { DateFormatter } from '@ddt-web/data-service';
import { DateUtil } from '@ddt-web/generic-utils';
import { MarketViewConfigService } from '@ddt-web/market-view';
import { UrlService } from '@ddt-web/url';
import * as get from 'lodash/get';
import * as isEmpty from 'lodash/isEmpty';
import { Observable, of } from 'rxjs';
import { filter, first, switchMap, take } from 'rxjs/operators';

import { ModelsBrowseDataService } from '../services';

@Component({
	selector: 'mb-family-commentary',
	templateUrl: './family-commentary.component.html',
	styleUrls: ['./family-commentary.component.scss']
})
export class FamilyCommentaryComponent implements OnInit {

	@InjectConfig(ModelsExperienceConfigKey.DATE_FORMAT) private readonly dateFormat: string = DateUtil.MODELS_US_DATE_FORMAT;

	public familyIds: Observable<Array<string>>;
	public asOfDate: string;
	public marketViewConfig$: Observable<any>;
	public shouldShowMarketView: boolean = false;
	private readonly isModelsRegroupingEnabled: boolean = true;

	constructor(
		private modelsBrowseDataService: ModelsBrowseDataService,
		private urlService: UrlService,
		private marketViewConfigService: MarketViewConfigService
	) { }

	public ngOnInit(): void {
		const familyId = this.urlService.getModelFamilyId();
		this.familyIds = of([familyId]);

		this.modelsBrowseDataService.fetchFamilyHoldings(familyId).pipe(
			first()
		).subscribe(holdings => {
			// Set asOfDate from holdings data
			const asOfDate = get(holdings[0], 'metadata.currentRebalanceDate');
			if (asOfDate) {
				this.asOfDate = new DateFormatter(this.dateFormat).format(asOfDate);
			}
		});

		if (this.isModelsRegroupingEnabled) {
			this.marketViewConfig$ = this.modelsBrowseDataService.getFamilyNameId(familyId).pipe(
				take(1),
				switchMap(familyNameId =>
					this.marketViewConfigService.fetchConfig(familyNameId).pipe(
						first(),
						filter(config => !isEmpty(config))
					)
				)
			);
		} else {
			this.marketViewConfig$ = this.marketViewConfigService.fetchConfig(familyId).pipe(
				first(),
				filter(config => !isEmpty(config))
			);
		}
	}

}
